import React from 'react';
import {StyledWrapper} from './styles';
import messages from './messages';
import {FormattedMessage} from 'components/FormattedComponents';

function ChecklistOptionScoreBagde({label}) {
  return (
    <StyledWrapper label={label}>
      {label}
      {!label && <FormattedMessage {...messages.noResponse} />}
    </StyledWrapper>
  );
}

export default ChecklistOptionScoreBagde;
